{
  "Clear search": "Ştergeţi căutarea"
}
